// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Lunarbox_Data_Dataflow_Runtime_TermEnvironment = require("../Lunarbox.Data.Dataflow.Runtime.TermEnvironment/index.js");
var ValueMap = function (x) {
    return x;
};
var semigroupValueMap = function (dictOrd) {
    return new Data_Semigroup.Semigroup(function (v) {
        return function (v1) {
            return ValueMap(Data_Semigroup.append(Data_Map_Internal.semigroupMap(dictOrd))(v)(v1));
        };
    });
};
var newtypeValueMap = new Data_Newtype.Newtype(function (n) {
    return n;
}, ValueMap);
var monoidValueMap = function (dictOrd) {
    return Data_Map_Internal.monoidMap(dictOrd);
};
var eqValueMap = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Internal.eqMap(dictEq)(Lunarbox_Data_Dataflow_Runtime_TermEnvironment.eqTerm(dictEq)))(x)(y);
        };
    });
};
var encodeJsonValueMap = function (dictEncodeJson) {
    return function (dictOrd) {
        return Data_Argonaut_Encode_Class.encodeMap(dictOrd)(dictEncodeJson)(Lunarbox_Data_Dataflow_Runtime_TermEnvironment.encodeJsonTerm(dictEncodeJson));
    };
};
var defaultValueMap = new Data_Default.Default(ValueMap(Data_Map_Internal.empty));
var decodeJsonValueMap = function (dictDecodeJson) {
    return function (dictOrd) {
        return Data_Argonaut_Decode_Class.decodeMap(dictOrd)(dictDecodeJson)(Lunarbox_Data_Dataflow_Runtime_TermEnvironment.decodeJsonTerm(dictDecodeJson));
    };
};
module.exports = {
    ValueMap: ValueMap,
    eqValueMap: eqValueMap,
    newtypeValueMap: newtypeValueMap,
    semigroupValueMap: semigroupValueMap,
    monoidValueMap: monoidValueMap,
    encodeJsonValueMap: encodeJsonValueMap,
    decodeJsonValueMap: decodeJsonValueMap,
    defaultValueMap: defaultValueMap
};
